"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayToMap = void 0;
/**
 * Converts an array of objects to a map: { key: object }
 * @param arr Array of objects
 * @param key Key of the objects to use as the mapping key
 */
function arrayToMap(arr, key) {
    var map = {};
    arr.forEach(function (obj) {
        map[obj[key]] = obj;
    });
    return map;
}
exports.arrayToMap = arrayToMap;
//# sourceMappingURL=arrayToMap.js.map